<template>
	<div>
		<div class="accessRecordStatisticsQueryBox">
			<div class="queryBox">
				<span class="queryTitle">开始时间</span>
				<span class="queryValue">
					<el-date-picker size="medium" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期" v-model="timeParams.beginTime"></el-date-picker>
				</span>
			</div>
			<div class="queryBox">
				<span class="queryTitle">结束时间</span>
				<span class="queryValue"><el-date-picker size="medium" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期" v-model="timeParams.endTime"></el-date-picker></span>
			</div>
			<el-button class="queryBox" size="medium" type="primary" @click="loadData">搜索</el-button>

			<el-button class="queryBox" size="medium" type="primary" @click="exportExcel">导出</el-button>
		</div>
		<div class="topTable">
			<el-table :data="tableData" border style="width: 100%; margin-top: 20px">
				<el-table-column prop="userName" label="姓名" align="center" width="180"></el-table-column>
				<el-table-column prop="autoId" label="样本编号" align="center"></el-table-column>
				<el-table-column label="样本状态" align="center">
					<template slot-scope="scope">
						{{ statusValue(scope.row.status) }}
					</template>
				</el-table-column>
				<el-table-column prop="areaCode" label="区号" align="center"></el-table-column>
				<el-table-column prop="phone" label="电话号码" align="center"></el-table-column>
				<el-table-column prop="type" label="访问状态" align="center">
					<template slot-scope="scope">
						{{ typeValue(scope.row.type) }}
					</template>
				</el-table-column>
				<el-table-column prop="beginTime" label="开始时间" align="center"></el-table-column>
				<el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
				<el-table-column prop="playPath" label="播放录音" align="center">
					<template slot-scope="scope">
						<i v-if="scope.row.playPath != ''" class="el-icon-video-play" style="font-size:40px; color: aquamarine; cursor: pointer;" @click="mp3Play(scope.row)"></i>
					</template>
				</el-table-column>
				<el-table-column prop="minute" label="访问分钟数" align="center"></el-table-column>
			</el-table>
			<div class="block">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pagination.currentPage"
					:page-sizes="[1, 10, 50, 100, 200, 300, 400]"
					:page-size="pagination.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.total"
				></el-pagination>
			</div>
		</div>
		<audio id="resource" ref="up" :src="audioSrc" controls style="display: none;"></audio>
	</div>
</template>

<script>
export default {
	props: {
		surveyId: {
			type: String
		},
		source: {
			type: String
		}
	},
	data() {
		return {
			queryInterviewstateData:[],
			statusList: ['无', '初始', '读取', '中断', '甄别', '条件不符', '完成', '配额已满', '无效样本', '预拨取号', '审核作废', '稍后', '约访', '预拨作废'],
			audioSrc: '',
			timeParams: {
				beginTime: '',
				endTime: ''
			},
			pagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			tableData: []
		};
	},
	created() {
		this.loadData();
		this.queryInterviewstate()
	},
	methods: {
		typeValue(value){
			let typeText = '';
			this.queryInterviewstateData.forEach((item, index) => {
				// console.log(item)
				if (value == item.isId) {
					typeText = item.isState;
				}
			});
			return typeText;
		},
		queryInterviewstate() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.oneQueryInterviewstate}?pageNo=${1}&pageSize=${1000}&qid=${this.surveyId}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.queryInterviewstateData = res.resultBody.records;
					} else {
						that.queryInterviewstateData = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		statusValue(value) {
			let statusText = '';
			this.statusList.forEach((item, index) => {
				if (value == index) {
					statusText = item;
				}
			});
			return statusText;
		},
		mp3Play(scope) {
			this.audioSrc = scope.playPath;
			var dom = this.$refs.up;
			dom.load();
			dom.play();
		},
		loadData() {
			let data = {
				userName: this.timeParams.name,
				beginTime: this.timeParams.beginTime,
				endExamTime: this.timeParams.endTime,
				currentPage: this.pagination.currentPage,
				pageSize: this.pagination.pageSize,
				source: this.source,
				surveyId: this.surveyId
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryOneSampleAccessRecordStatistics}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.tableData = res.resultBody.records;
						that.pagination.total = res.resultBody.total;
					} else {
						that.tableData = [];
						that.pagination.total = 0;
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pagination.pageSize = val;
			this.loadData();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.pagination.currentPage = val;
			this.loadData();
		}
		,
		exportExcel() {
			const loading = this.$loading({
				lock: true,
				text: '正在导出中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let that = this;
			let data = {
				userName: this.timeParams.name,
				beginTime: this.timeParams.beginTime,
				endExamTime: this.timeParams.endTime,
				source: this.source,
				surveyId: this.surveyId
			};
			let params = {
				that: this,
				url: `${this.$config.service.exportOneSampleAccessRecordStatistics}`,
				method: 'POST',
				responseType: 'arraybuffer',
				data: data,
				cb(resp) {
					let headers = resp.headers;
					let contentType = headers['content-type'];
					console.log('响应头信息', headers);
					if (!resp.data) {
						console.error('响应异常：', resp);
						loading.close();
						return false;
					} else {
						const blob = new Blob([resp.data], { type: contentType });
						const contentDisposition = resp.headers['content-disposition'];
						let fileName = 'unknown';
						if (contentDisposition) {
							fileName = window.decodeURI(resp.headers['content-disposition'].split('=')[1]);
						}
						let link = document.createElement('a');
						link.href = window.URL.createObjectURL(blob); // 创建下载的链接
						link.download = fileName; // 下载后文件名
						link.style.display = 'none';
						document.body.appendChild(link);
						link.click(); // 点击下载
						window.URL.revokeObjectURL(link.href); // 释放掉blob对象
						document.body.removeChild(link); // 下载完成移除元素
						loading.close();
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped lang="scss">
.el-row {
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}
.accessRecordStatisticsQueryBox {
	display: flex;
	.queryBox {
		display: flex;
		margin-left: 10px;
		align-items: center;
		.queryTitle {
			// line-height: 40px;
			font-size: 14px;
		}
		.queryValue {
			margin-left: 10px;
		}
	}
	.queryBox:first-child {
		margin-left: 0px;
	}
}

.topTable {
	margin-bottom: 20px;
	.block {
		text-align: right;
		margin-top: 20px;
	}
}
</style>
